// Common API configuration and utilities
import { customAlphabet } from 'nanoid';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY;
const SUPABASE_API_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  console.log('SUPABASE_URL and SUPABASE_KEY must be set');
}
else {
  console.log('SUPABASE_URL and SUPABASE_KEY are set');
}

export const API_BASE_URL = `${SUPABASE_URL}/functions/v1`;
export const API_KEY = SUPABASE_API_KEY;

export const generateAlphanumericId = customAlphabet('abcdefghijklmnopqrstuvwxyz0123456789', 10);

export const headers = {
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${API_KEY}`
};

export const STEP_STORAGE_KEY = 'figabl_current_step';
